module.exports = __webpack_public_path__ + "media/images/emblems/Cerentino-coat_of_arms-fc3e018fc0c5e67e6fb4a99e2a7e5968.svg";